import UsefulQuestion from './UsefulQuestion';

export default UsefulQuestion;
